import { TERMINAL_DEFAULT_VALUE } from "components/filters/ToggleTerminalsFilter";
import { AppList } from "components/list/AppList";
import { useGridUserDataGlobalFiltersContext } from "contexts/GridUserDataGlobalFiltersProvider";
import { useUserSettingsContext } from "contexts/UserSettingsProvider";
import React from "react";
import { Datagrid, FunctionField, Loading, ReferenceField, TextField } from "react-admin";

import { DatagridWithBlockProps } from "../../../components/_helpers/props/DatagridProps";
import { PriceField } from "../../../components/fields/PriceField";
import { ScrollingWrapper } from "../../../components/ScrollingWrapper";
import GridUserDataProvider, {
	useGridUserDataContext,
} from "../../../contexts/GridUserDataProvider";

const defaultSort = { field: "code", order: "DESC" };
const filterDefaultValues = {
	terminal_id: [TERMINAL_DEFAULT_VALUE],
};

const articleRowStyle = (record) => {
	return {
		backgroundColor: record.color,
	};
};

const _ArticlesList = (props) => {
	const { filters: _currentFilters, sort: currentSort } = useGridUserDataContext();
	const { data: globalFilters = {} } = useGridUserDataGlobalFiltersContext();
	const currentFilters = { ..._currentFilters, currency: props.currency, ...globalFilters };

	if (!props.permissions || currentFilters === undefined) {
		return <Loading loadingSecondary="" />;
	}

	return (
		<AppList
			{...props}
			exporter={false}
			bulkActionButtons={false}
			sort={currentSort}
			pagination={null}
			filterDefaultValues={currentFilters}
			filter={currentFilters}
			actions={null}
		>
			<ScrollingWrapper>
				<Datagrid
					{...DatagridWithBlockProps}
					rowStyle={articleRowStyle}
					rowClick={null}
					size="small"
				>
					<TextField source="code" sortable={false} />

					<ReferenceField source="terminal_id" reference="terminal" link={false} sortable={false}>
						<TextField label="Terminal" source="name" />
					</ReferenceField>

					<TextField source="name" sortable={false} />
					<TextField source="calculation" sortable={false} />
					<PriceField source="price" mainCurrency={props.currency} hideCurrencyPrefix sortable={false} />
					<FunctionField source="currency" sortable={false} render={() => props.currency} />
					<TextField source="service_description" sortable={false} />
				</Datagrid>
			</ScrollingWrapper>
		</AppList>
	);
};

export const ArticlesList = (props) => {
	const { data: userSettings } = useUserSettingsContext();
	if (!userSettings) return null;

	const currency = userSettings.company_settings.currency;

	return (
		<GridUserDataProvider
			resource={props.resource}
			filterDefaultValues={filterDefaultValues}
			sortDefaultValues={defaultSort}
		>
			<_ArticlesList {...props} currency={currency} />
		</GridUserDataProvider>
	);
};
